import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { renderRoutes } from 'react-router-config'

import {
  AssessorApprovalModal,
  AlreadyAssessedModal,
  LeaderApprovalModal
} from 'components/modals'
import {
  ActivitySubHeader,
  ActivityToasts
} from 'components/sections/dashboard'
import { DashboardGrid as Grid } from 'components/layout'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { modal } from 'helpers/decorators'
import { apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import MODALS from 'constants/layout/modals'
import { ACTION_DISCRIMINATORS, ACTIVITY_STATES, CONFIGURATION_KEYS } from 'constants/enums'
import config from 'config'
import { connect } from 'react-redux'
import { isAssessorManagementEnabledForActivity } from '../../../helpers/assessorHelper'

@modal.trigger()
@apiDashboard.apiActivity({
  loaders: ['approval']
})
@apiConfiguration({ getValue: CONFIGURATION_KEYS.isPersonalReflectionFroActivityEnabled.id })
@connect(
  ({ api }) => ({
    award: api.awards.data,
    actions: api.actions.list
  }),
  {}
)
class Activity extends Component {
  static propTypes = {
    onSendAssessmentRequest: PropTypes.func,
    onSendAlreadyAssessed: PropTypes.func,
    onSendLeaderRequest: PropTypes.func,
    onResendAssessmentRequest: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    approvalStatus: PropTypes.object,
    params: PropTypes.object,
    route: PropTypes.object,
    awards: PropTypes.object,
    notification: PropTypes.func,
    onGetConfigurationValue: PropTypes.func,
    award: PropTypes.object,
    actions: PropTypes.object
  }

  static defaultProps = {
    params: {}
  }

  componentDidUpdate(prevProps) {
    const { params, awards } = this.props

    const completedPercentage = get(
      awards,
      `activities.ID_${params.activityId}.completedPercentage`
    )
    const completedPercentagePrev = get(
      prevProps.awards,
      `activities.ID_${prevProps.params.activityId}.completedPercentage`
    )

    if (
      get(params, 'activityId') &&
      completedPercentage !== completedPercentagePrev
    ) {
      this.openAssessment(get(params, 'activityId'))
    }

    if (params.activityId !== prevProps.params.activityId) {
      this.openAssessment(get(params, 'activityId'))
    }
  }

  assessmentReqResent = []

  openAssessment = activityId => {
    const { awards } = this.props

    const activity = get(awards, `activities.ID_${activityId}`)
    const returnedToParticipant = get(activity, `returnedToParticipant`)

    if (get(activity, 'canBeSentForAssessment') === true && !returnedToParticipant) {
      this.handleOpenAssessorApproval()
    }
    if (get(activity, 'canBeSentForSignoff') === true) {
      this.handleOpenLeaderApproval()
    }
  }

  handleSendLeaderRequest = (fields, { resetForm }) => {
    const lastPersonalReflection = this.getLastPersonalReflection(this.props.actions, ACTION_DISCRIMINATORS.activityAssessmentAction.code)

    this.props.onSendLeaderRequest(
      get(this.props.params, 'activityId'),
      lastPersonalReflection,
      fields,
      { resetForm }
    )
  }

  handleSendAlreadyAssessed = (fields, { resetForm }) =>
    this.props.onSendAlreadyAssessed(
      get(this.props.params, 'activityId'),
      fields,
      { resetForm }
    )

  handleSendAssessmentRequest = (fields, { resetForm }) =>
    this.props.onSendAssessmentRequest(
      get(this.props.params, 'activityId'),
      fields,
      { resetForm }
    )

  handleOpenAssessorApproval = () =>
    this.props.onOpen(MODALS.SEND_ASSESSOR_APPROVAL, null, null)

  handleOpenAlreadyAssessed = () => {
    this.props.onClose()
    setTimeout(() => {
      this.props.onOpen(MODALS.SEND_ALREADY_ASSESSED, null, null)
    }, 500)
  }

  handleResendAssessmentRequest = actId => {
    if (!this.assessmentReqResent.includes(actId)) {
      this.assessmentReqResent.push(actId)
      this.props.onResendAssessmentRequest(actId)
    } else {
      this.props.notification(
        'You have already resent the assessment request',
        {
          status: 'info',
          intlKey: 'notifications.already_resent_assessment_request'
        }
      )
    }
  }

  handleOpenLeaderApproval = () =>
    this.props.onOpen(MODALS.SEND_LEADER_APPROVAL, null, null)

  getLastPersonalReflection = (actions, discriminator) => {
    let actAssesmentRequestActions = actions.filter(a => get(a, 'discriminator') === discriminator)

    actAssesmentRequestActions = actAssesmentRequestActions && actAssesmentRequestActions.sort((a, b) => new Date(get(b, 'createdAt')) - new Date(get(a, 'createdAt')))
    return actAssesmentRequestActions && actAssesmentRequestActions.length > 0 ? get(actAssesmentRequestActions[0], 'personalReflection') : ''
  }



  render() {
    const { awards, route, params, approvalStatus, configuration, actions } = this.props

    const activeActivity = get(awards, `activities.ID_${params.activityId}`)

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(activeActivity)

    const assessorEmail = get(activeActivity, 'assessorEmail')

    const completedPercentage = get(activeActivity, 'completedPercentage')

    const activeActivitySection = get(activeActivity, 'activitySection.value')

    const colorClass = getActivityClassName(
      get(activeActivity, 'activitySection.value')
    )

    const isAssessmentPositive = get(activeActivity, 'isAssessmentPositive')

    const activityState = get(activeActivity, 'activityState.value')

    const isAwaitingAssessment =
      ACTIVITY_STATES.assessment.id === activityState &&
      completedPercentage === 100 &&
      !isAssessmentPositive

    const isReadOnly =
      [
        ACTIVITY_STATES.award_leader_singoff.id,
        ACTIVITY_STATES.office_signoff.id
      ].includes(get(activeActivity, 'activityState.value')) ||
      isAwaitingAssessment

    const isPersonalReflectionCfg = get(configuration, `values[${CONFIGURATION_KEYS.isPersonalReflectionFroActivityEnabled.id}]`)

    const isPersonalReflectionEnabled = isPersonalReflectionCfg  && get(isPersonalReflectionCfg , 'booleanValue')

    const lastPersonalReflection = this.getLastPersonalReflection(actions, ACTION_DISCRIMINATORS.activityAssessmentRequestAction.code)

    return (
      <Grid.RightOuter>
        <ActivitySubHeader
          activityRoute={`${config.publicPath}/dashboard/awards/${params.awardId}/activity/${params.activityId}`}
          activitySection={activeActivitySection || 'none'}
          completedPercentage={completedPercentage}
          title={get(activeActivity, 'activityCategory.translatedName')}
          subtitle={get(activeActivity, 'completionText')}
          isMajor={get(activeActivity, 'isMajor')}
        />
        {route && renderRoutes(route.routes, {
          params,
          isReadOnly,
          activity: activeActivity,
          onOpenAssessorApproval: this.handleOpenAssessorApproval,
          onOpenLeaderApproval: this.handleOpenLeaderApproval,
          loading: get(awards, 'loading')
        })}
        <ActivityToasts
          activity={activeActivity}
          onResendAssessmentRequest={() =>
            this.handleResendAssessmentRequest(get(activeActivity, 'id'))}
          onOpenAssessorApproval={this.handleOpenAssessorApproval}
          onOpenLeaderApproval={this.handleOpenLeaderApproval}
        />
        <AssessorApprovalModal
          modalId={MODALS.SEND_ASSESSOR_APPROVAL}
          onOpenAlreadyAssessed={this.handleOpenAlreadyAssessed}
          onSubmit={this.handleSendAssessmentRequest}
          colorClass={colorClass}
          loading={get(approvalStatus, 'loading')}
          noAssessor={!assessorEmail}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
          isPersonalReflectionEnabled={isPersonalReflectionEnabled}
          lastPersonalReflection={lastPersonalReflection}
        />
        <LeaderApprovalModal
          modalId={MODALS.SEND_LEADER_APPROVAL}
          onSubmit={this.handleSendLeaderRequest}
          colorClass={colorClass}
          loading={get(approvalStatus, 'loading')}
        />
        <AlreadyAssessedModal
          modalId={MODALS.SEND_ALREADY_ASSESSED}
          onSubmit={this.handleSendAlreadyAssessed}
          colorClass={colorClass}
          loading={get(approvalStatus, 'loading')}
        />
      </Grid.RightOuter>
    )
  }
}

export default Activity
